export enum BaseSection {
  ASSIGNED_VEHICLES,
  ASSIGNED_DRIVERS,
}
